import React from 'react'
import { ThemeProvider } from '@material-ui/core'

import getTheme from './index'

const MobileThemeProvider = ({ children }) => (
  <ThemeProvider theme={(theme) => getTheme({ type: 'light', theme })}>{children}</ThemeProvider>
)

export default MobileThemeProvider
